module.exports = __webpack_public_path__ + "NotoSansKR-Medium-Hestia.67964.woff";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/fonts/woff/NotoSansKR-Medium-Hestia.woff
// module id = ./src/_asset/sources/assets/fonts/woff/NotoSansKR-Medium-Hestia.woff
// module chunks = main